<template>
  <div class="safeguardDepartment">
    <el-button type="primary" icon="el-icon-plus" class="creatButton" @click="insertEvent(-1)">{{
      $t('businesDepartment.businesList.add')
    }}</el-button>
    <el-button type="primary" icon="el-icon-plus" class="creatButton" @click="copyEvent(-1)">{{
      $t('businesDepartment.businesList.copy')
    }}</el-button>
    <el-button
      type="primary"
      icon="el-icon-delete"
      class="deteButton"
      @click="handleDelete('xTable')"
      >{{ $t('businesDepartment.businesList.delete') }}</el-button
    >
    <el-button
      type="primary"
      icon="el-icon-edit"
      class="creatButton"
      @click="save"
      :loading="load"
      >{{ $t('businesDepartment.businesList.save') }}</el-button
    >
    <el-button type="primary" icon="el-icon-upload" class="deteButton" @click="upLoade">{{
      $t('businesDepartment.businesList.upLoade')
    }}</el-button>
    <vxe-table
      border
      :auto-resize="true"
      show-overflow
      size="mini"
      ref="xTable"
      :data="tableData"
      :edit-rules="validRules"
      :max-height="$store.state.app.tableHeight"
      @edit-actived="editActivedEvent"
      :edit-config="{ trigger: 'click', mode: 'row', showStatus: true }"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
      :valid-config="{ autoPos: true, message: 'inline' }"
    >
      <vxe-table-column type="checkbox" min-width="50" fixed="left"></vxe-table-column>
      <vxe-table-column
        type="index"
        :title="$t('currenciesAndCalendar.queryCurrencies.index')"
        min-width="50"
      ></vxe-table-column>
      <vxe-table-column
        field="planCompanyCode"
        :title="$t('businesDepartment.businesList.company')"
        :edit-render="{ type: 'default' }"
        min-width="210"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="getSelectLabel(scope.row.planCompanyCode, companyList)"
            placement="bottom"
            :disabled="
              scope.row.planCompanyCode == '' || scope.row.planCompanyCode == null ? true : false
            "
          >
            <el-select
              v-model="scope.row.planCompanyCode"
              filterable
              @change="companyChange(scope, 1)"
              clearable
            >
              <el-option
                v-for="item in companyList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{ getSelectLabel(row.planCompanyCode, companyList) }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="planDepartmentCode"
        :title="$t('businesDepartment.businesList.department')"
        :edit-render="{ type: 'default' }"
        min-width="210"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.planDepartmentName"
            placement="bottom"
            :disabled="
              scope.row.planDepartmentCode == '' || scope.row.planDepartmentCode == null
                ? true
                : false
            "
          >
            <el-select
              v-model="scope.row.planDepartmentCode"
              filterable
              @change="departmentChange(scope)"
              clearable
            >
              <el-option
                v-for="item in planDepartmentList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{ row.planDepartmentName }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="planCycle"
        :title="$t('businesDepartment.businesList.planWeek')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="getSelectLabel(scope.row.planCycle, planWeekList)"
            placement="bottom"
            :disabled="scope.row.planCycle == '' || scope.row.planCycle == null ? true : false"
          >
            <el-select
              v-model="scope.row.planCycle"
              filterable
              @change="changPlanDate(scope, 'planCycle')"
              clearable
            >
              <el-option
                v-for="item in planWeekList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{ getSelectLabel(row.planCycle, planWeekList) }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="year"
        :title="$t('businesDepartment.businesList.year')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="getSelectLabel(scope.row.year, yearList) + ''"
            placement="bottom"
            :disabled="scope.row.year == '' || scope.row.year == null ? true : false"
          >
            <el-select
              v-model="scope.row.year"
              filterable
              @change="changPlanDate(scope, 'year')"
              clearable
            >
              <el-option
                v-for="item in yearList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{ getSelectLabel(row.year, yearList) }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="month"
        :title="$t('businesDepartment.businesList.month')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="getSelectLabel(scope.row.month, monthList) + ''"
            placement="bottom"
            :disabled="scope.row.month == '' || scope.row.month == null ? true : false"
          >
            <el-select
              v-model="scope.row.month"
              filterable
              @change="changPlanDate(scope, 'month')"
              clearable
            >
              <el-option
                v-for="item in monthList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{ getSelectLabel(row.month, monthList) }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="planStartDate"
        :title="$t('businesDepartment.businesList.planStartDate')"
        min-width="200"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="{ row }">
          <el-tooltip
            class="item"
            effect="dark"
            :content="formatDate(row.planStartDate, 'yyyy/MM/dd') + ''"
            placement="bottom"
            :disabled="row.planStartDate == '' || row.planStartDate == null ? true : false"
          >
            <el-date-picker
              v-model="row.planStartDate"
              type="date"
              format="yyyy/MM/dd"
              clearable
              :default-value="
                row.year == null || row.month == null || row.year == '' || row.month == ''
                  ? new Date()
                  : new Date(row.year + '-' + row.month)
              "
              :picker-options="pickerTimeOptions"
              @focus="
                () => handleFocusDateFin(row.year, row.month, row.planStartDate, row.planEndDate)
              "
              @change="changPlanDate2(row)"
            ></el-date-picker>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{ formatDate(row.planStartDate, 'yyyy/MM/dd') }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="planEndDate"
        :title="$t('businesDepartment.businesList.planEndDate')"
        min-width="200"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="{ row }">
          <el-tooltip
            class="item"
            effect="dark"
            :content="formatDate(row.planEndDate, 'yyyy/MM/dd') + ''"
            placement="bottom"
            :disabled="row.planEndDate == '' || row.planEndDate == null ? true : false"
          >
            <el-date-picker
              v-model="row.planEndDate"
              type="date"
              format="yyyy/MM/dd"
              clearable
              :default-value="
                row.year == null || row.month == null || row.year == '' || row.month == ''
                  ? new Date()
                  : new Date(row.year + '-' + row.month)
              "
              :picker-options="pickerTimeOptions"
              @focus="
                () => handleFocusDateFin(row.year, row.month, row.planStartDate, row.planEndDate)
              "
            ></el-date-picker>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{ formatDate(row.planEndDate, 'yyyy/MM/dd') }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="productName"
        :title="$t('businesDepartment.businesList.productName')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <search-table
            :disabled="scope.row.bizFlag == 1"
            v-model="scope.row.productName"
            searchType="goodsDetail"
            propName="productName"
            :isMultiple="true"
            :extraData="{ detailProductStatus: 'ZT03', adminFlag: userInfo.adminFlag }"
            :currentValue="scope.row.productName ? scope.row.productName : ''"
            :checkRowKeys="scope.row.productCode ? [scope.row.productCode] : []"
            @input="(val) => chooseTable(val, scope.row, 'productName', scope)"
          ></search-table>

          <!-- <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.productName"
            placement="bottom"
            :disabled="scope.row.productName == ''||scope.row.productName == null? true:false"
          >
            <el-input
              v-model="scope.row.productName"
              @input="$refs.xTable.updateStatus(scope)"
              maxlength="32"
              clearable
            ></el-input>
          </el-tooltip> -->
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="cashType"
        :title="$t('businesDepartment.businesList.cashType')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="getSelectLabel(scope.row.cashType, paymentTypeList) + ''"
            placement="bottom"
            :disabled="scope.row.cashType == '' || scope.row.cashType == null ? true : false"
          >
            <el-select
              v-model="scope.row.cashType"
              filterable
              @change="$refs.xTable.updateStatus(scope)"
              clearable
            >
              <el-option
                v-for="item in paymentTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{ getSelectLabel(row.cashType, paymentTypeList) }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="partnerName"
        :title="$t('businesDepartment.businesList.partnerName')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <search-table
            :disabled="scope.row.bizFlag == 1"
            v-model="scope.row.partnerName"
            searchType="supplier"
            propName="partnerName"
            :isMultiple="true"
            :extraData="{
              companyCode: scope.row.planCompanyCode,
              departmentCode: scope.row.planDepartmentCode,
              partnerTypes: 'HZHB03,HZHB02',
            }"
            :currentValue="scope.row.partnerName ? scope.row.partnerName : ''"
            :checkRowKeys="scope.row.partnerNo ? [scope.row.partnerNo] : []"
            @input="(val) => chooseTable(val, scope.row, 'partnerName', scope)"
          ></search-table>
          <!-- <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.partnerName+''"
            placement="bottom"
            :disabled="scope.row.partnerName == ''||scope.row.partnerName == null? true:false"
          >
            <el-input v-model="scope.row.partnerName" @input="$refs.xTable.updateStatus(scope)" maxlength="32" clearable></el-input>
          </el-tooltip> -->
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="quantity"
        :title="$t('businesDepartment.businesList.quantity')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.quantity + ''"
            placement="bottom"
            :disabled="scope.row.quantity == '' || scope.row.quantity == null ? true : false"
          >
            <input-number
              v-model="scope.row.quantity"
              :max="999999999.999999"
              :precision="$globalVar.qPoint"
              :clearable="true"
              @change="changPaymentType(scope)"
            ></input-number>
          </el-tooltip>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="unitPrice"
        :title="$t('businesDepartment.businesList.unitPrice')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.unitPrice + ''"
            placement="bottom"
            :disabled="scope.row.unitPrice == '' || scope.row.unitPrice == null ? true : false"
          >
            <input-number-ad
              v-model="scope.row.unitPrice"
              :max="99999999999.999999"
              :precision="$globalVar.pPoint"
              :clearable="true"
              @change="changPaymentType(scope)"
            ></input-number-ad>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{
          $baseRequest.formatTableColumn(row.unitPrice, $globalVar.pPoint)
        }}</template>
        <!-- <template v-slot="{ row }">
             {{ row["unitPrice"]|formatTableColumn("formatAmountRound")}}
        </template> -->
      </vxe-table-column>
      <vxe-table-column
        field="paymentType"
        :title="$t('businesDepartment.businesList.paymentType')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="getSelectLabel(scope.row.paymentType, payForWayList) + ''"
            placement="bottom"
            :disabled="scope.row.paymentType == '' || scope.row.paymentType == null ? true : false"
          >
            <el-select
              v-model="scope.row.paymentType"
              filterable
              @change="changPaymentType(scope)"
              clearable
            >
              <el-option
                v-for="item in payForWayList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{ getSelectLabel(row.paymentType, payForWayList) }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="receiveAmount"
        :title="$t('businesDepartment.businesList.receiveAmount')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.receiveAmount + ''"
            placement="bottom"
            :disabled="
              scope.row.receiveAmount == '' || scope.row.receiveAmount == null ? true : false
            "
          >
            <input-number-ad
              v-model="scope.row.receiveAmount"
              :max="99999999999.999999"
              :clearable="true"
              :disabled="scope.row.paymentType == 'SK02' ? true : false"
              @input="$refs.xTable.updateStatus(scope)"
            ></input-number-ad>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">
          {{ row['receiveAmount'] | formatTableColumn('formatAmountRound') }}
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="payAmount"
        :title="$t('businesDepartment.businesList.payAmount')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.payAmount + ''"
            placement="bottom"
            :disabled="scope.row.payAmount == '' || scope.row.payAmount == null ? true : false"
          >
            <input-number-ad
              v-model="scope.row.payAmount"
              :max="99999999999.999999"
              :clearable="true"
              :disabled="scope.row.paymentType == 'SK01' ? true : false"
              @input="$refs.xTable.updateStatus(scope)"
            ></input-number-ad>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">
          {{ row['payAmount'] | formatTableColumn('formatAmountRound') }}
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="paymentDate"
        :title="$t('businesDepartment.businesList.paymentDate')"
        min-width="200"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="{ row }">
          <el-tooltip
            class="item"
            effect="dark"
            :content="formatDate(row.paymentDate, 'yyyy/MM/dd') + ''"
            placement="bottom"
          >
            <el-date-picker
              v-model="row.paymentDate"
              type="date"
              format="yyyy/MM/dd"
              clearable
              :disabled="row.planCycle == 'MP' || row.planCycle == 'HMP' ? true : false"
              :default-value="
                row.year == null || row.month == null || row.year == '' || row.month == ''
                  ? new Date()
                  : new Date(row.year + '-' + row.month)
              "
              :picker-options="pickerTimeOptions"
              @focus="() => handleFocusDateFinPaymentDate(row.planStartDate, row.planEndDate)"
            ></el-date-picker>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{ formatDate(row.paymentDate, 'yyyy/MM/dd') }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="currencyType"
        :title="$t('businesDepartment.businesList.currencyType')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="getSelectLabel(scope.row.currencyType, currencyList) + ''"
            placement="bottom"
            :disabled="
              scope.row.currencyType == '' || scope.row.currencyType == null ? true : false
            "
          >
            <el-select
              v-model="scope.row.currencyType"
              filterable
              @change="$refs.xTable.updateStatus(scope)"
              clearable
            >
              <el-option
                v-for="item in currencyList"
                :key="item.value"
                :label="item.label + '  ' + item.value"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-tooltip>
        </template>
        <template v-slot="{ row }">{{ getSelectLabel(row.currencyType, currencyList) }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="inputPerson"
        :title="$t('businesDepartment.businesList.inputPerson')"
        min-width="140"
        :edit-render="{ name: 'input', defaultValue: `${user.userName}` }"
      >
        <template v-slot:edit="scope">
          <el-input
            v-model="scope.row.inputPerson"
            @input="$refs.xTable.updateStatus(scope)"
            disabled
          ></el-input>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="mark"
        :title="$t('businesDepartment.businesList.mark')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.mark"
            placement="bottom"
            :disabled="scope.row.mark == '' || scope.row.mark == null ? true : false"
          >
            <el-input
              v-model="scope.row.mark"
              @input="$refs.xTable.updateStatus(scope)"
              maxlength="256"
              clearable
            ></el-input>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <!-- <div class="block">
      <el-pagination
        v-if="pageShow"
        ref="page"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-count="page.pages"
        :current-page="page.pageNum || 1"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>-->
    <div class="sirui-upload">
      <!--上传excel-->
      <el-dialog
        :title="$t('import.importTitle')"
        :visible.sync="dialogUpload"
        :close-on-click-modal="false"
        append-to-body
        min-width="450px"
      >
        <el-upload
          class="upload-demo"
          ref="upload"
          :action="importUrl"
          :data="token"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-upload="beforeUpload"
          :on-success="handleSuccess"
          :file-list="fileList"
          :auto-upload="false"
          :multiple="false"
          :limit="1"
        >
          <el-button slot="trigger" size="small">{{ $t('import.chooseFile') }}</el-button>
          <el-button style="margin-left: 10px" size="small" type="primary" @click="submitUpload">{{
            $t('import.submitImport')
          }}</el-button>
          <div slot="tip" class="el-upload__tip">{{ $t('import.importTips') }}</div>
        </el-upload>
      </el-dialog>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/capitalPlane/businesDepartment';
  import BASEAPI from '@/api/dataBase.js';
  import InputNumber from '@/components/form-item/input-number';
  import searchTable from '@/components/form-item/search-table';
  import inputNumberAd from '@/components/form-item/input-number-advance';
  import XEUtils from 'xe-utils';
  import baseUrl from '@/common/config';
  export default {
    name: 'safeguardDepartment',
    components: {
      inputNumberAd,
      InputNumber,
      searchTable,
    },
    data() {
      return {
        page: {
          pages: 1,
          pageNum: 1,
          pageSize: 10,
          total: 0,
        },
        desable: false,
        dialogUpload: false,
        load: false,
        fileList: [],
        importUrl: '',
        action: '/financial/fundBusiness/importPlanBusinessExcel',
        validRules: {
          planCompanyCode: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.companyValidRules')}`,
            },
          ],
          planDepartmentCode: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.departmentValidRules')}`,
            },
          ],
          year: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.yearValidRules')}`,
            },
          ],
          month: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.monthValidRules')}`,
            },
          ],
          //物料
          productName: [
            {
              min: 0,
              max: 250,
              message: this.$t('currenciesAndCalendar.rules.writeLength'),
            },
          ],
          //合作伙伴
          partnerName: [
            {
              min: 0,
              max: 250,
              message: this.$t('currenciesAndCalendar.rules.writeLength'),
            },
          ],
          planCycle: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.planCycleValidRules')}`,
            },
          ],
          planStartDate: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.planStartDateValidRules')}`,
            },
          ],
          planEndDate: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.planEndDateValidRules')}`,
            },
          ],
          paymentType: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.paymentTypeValidRules')}`,
            },
          ],
          // currencyType: [
          //   {
          //     min: 0,
          //     max: 250,
          //     message: `${this.$t(
          //       "businesDepartment.businesList.currencyTypeValidRules"
          //     )}`
          //   }
          // ],
          quantity: [
            {
              min: 0,
              max: 20,
              message: `${this.$t('businesDepartment.businesList.quantityValidRules')}`,
            },
          ],
          //单价
          unitPrice: [
            {
              min: 0,
              max: 20,
              message: this.$t('currenciesAndCalendar.rules.writeLength'),
            },
          ],
          /* receiveAmount: [
          {
            required: true,
            message: `${this.$t(
              "businesDepartment.businesList.receiveAmountValidRules"
            )}`
          },
          {
            min: 0,
            max: 20,
            message: this.$t("currenciesAndCalendar.rules.writeLength")
          }
        ],
        payAmount: [
          {
            required: true,
            message: `${this.$t(
              "businesDepartment.businesList.payAmountValidRules"
            )}`
          },
          {
            min: 0,
            max: 20,
            message: this.$t("currenciesAndCalendar.rules.writeLength")
          }
        ], */
          mark: [
            {
              min: 0,
              max: 256,
              message: this.$t('currenciesAndCalendar.rules.writeLength'),
            },
          ],
          currencyType: [
            {
              required: true,
              message: `${this.$t('businesDepartment.businesList.currencyTypeRules')}`,
            },
          ],
        },
        tableData: [],
        companyDepartmentList: [], //公司部门
        companyList: [],
        planDepartmentList: [],
        planWeekList: [
          // {value:"1",label:"月计划"},
          // {value:"2",label:"半月计划"},
          // {value:"3",label:"日计划"},
          // {value:"4",label:"自定义计划"},
        ], //计划周期
        monthList: [
          {
            value: '1',
            label: '1' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '2',
            label: '2' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '3',
            label: '3' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '4',
            label: '4' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '5',
            label: '5' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '6',
            label: '6' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '7',
            label: '7' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '8',
            label: '8' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '9',
            label: '9' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '10',
            label: '10' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '11',
            label: '11' + this.$t('businesDepartment.businesList.mon'),
          },
          {
            value: '12',
            label: '12' + this.$t('businesDepartment.businesList.mon'),
          },
        ], //月份
        paymentTypeList: [], //款项类型列表
        payForWayList: [], //收付方式
        multipleSelection: [],
        currencyList: [], //币别
        yearList: [], //年度
        pageShow: false,
        flag: false,
        pickerTimeOptions: {}, //限制日期控件选择
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      user() {
        return this.userInfo.userInfo;
      },
      token() {
        return this.$baseRequest.assignObj({
          access_token: this.userInfo.userInfo.access_token,
        });
      },
      routerData() {
        return this.$route.query;
      },
    },
    mounted() {
      this.importUrl = baseUrl + this.action;
      this.getDictionary();
      this.getdata();
    },
    methods: {
      //表格组件下拉框选择回调
      getSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      //表格日期组件回调
      formatDate(value, format) {
        return XEUtils.toDateString(value, format);
      },
      //跳转
      toList() {
        let pathList = {
          fromPath: {
            path: '/capitalPlan/safeguardDepartment',
            name: 'safeguardDepartment',
            meta: {
              keepAlive: true,
              title: this.$t('businesDepartment.businesList.toSafeguardDepartment'),
            },
          },
          toPath: {
            path: '/capitalPlan/businesDepartment',
            name: 'businesDepartment',
            meta: {
              keepAlive: false,
              title: this.$t('businesDepartment.businesList.safeguardDepartment'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
      //表格下拉表格赋值
      chooseTable(val, row, field, scope) {
        if (field === 'partnerName') {
          row.partnerName = val ? val[0].partnerZhName : '';
        }
        if (field === 'productName') {
          row.productName = val ? val[0].detailProductDisplayName : '';
          //row.productCode=val?val[0].productCode:'';
        }

        this.$refs.xTable.updateStatus(scope);
      },
      editActivedEvent(row) {
        this.companyChange(row);
      },
      // 获取公司部门
      async companyChange(val, type) {
        if (type == 1) {
          val.row.planDepartmentCode = null;
          val.row.planDepartmentName = null;
          val.row.partnerName = null;
          val.row.partnerNo = null;
        }
        let personDepartmentInfo = [];
        if (val) {
          const params = {
            id: this.userInfo.userInfo.userCode,
            userCode: this.userInfo.userInfo.userCode,
            personName: this.userInfo.userInfo.userName,
            personCompanyCode: val.row.planCompanyCode,
          };
          const selectStatus = await this.$axios.post(BASEAPI.GET_PERSON_API, params);
          //let res = await this.$baseRequest.getDepartment(val.row.planCompanyCode);
          if (selectStatus) {
            personDepartmentInfo = selectStatus.data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
            if (val.row) {
              if (val.row.planCompanyCode) {
                this.planDepartmentList = personDepartmentInfo;
              }
            } else {
              if (this.searchForm.planCompanyCode) {
                this.departmentList = personDepartmentInfo;
              } else {
                this.departmentList = [];
              }
            }
            this.departmentList = selectStatus.data.data.personDepartmentInfo;
          }
        } else {
          this.planDepartmentList = personDepartmentInfo;
        }
        this.$refs.xTable.updateStatus(val);
      },
      departmentChange(val) {
        val.row.partnerName = null;
        val.row.partnerNo = null;

        val.row.planDepartmentName = this.planDepartmentList.find(
          (item) => item.value === val.row.planDepartmentCode
        ).label;
        this.$refs.xTable.updateStatus(val);
      },
      //导入
      upLoade() {
        this.dialogUpload = true;
      },
      beforeUpload(file) {
        var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
        const extension = testmsg === 'xls';
        const extension2 = testmsg === 'xlsx';
        const isLt2M = file.size / 1024 / 1024 < 20;
        if (!extension && !extension2) {
          this.$message({
            showClose: true,
            message: this.$t('import.importType'),
            type: 'error',
          });
        }
        if (!isLt2M) {
          this.$message({
            showClose: true,
            message: this.$t('import.importLimit'),
            type: 'error',
          });
        }
        return extension || (extension2 && isLt2M);
      },
      submitUpload() {
        this.$refs.upload.submit();
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleSuccess(res) {
        if (res.code == 0) {
          this.dialogUpload = false;
          /* this.tableData = this.tableData.concat(res.data);
        this.tableData.forEach(item => {
          item.companyDepartment = [
            item.planCompanyCode,
            item.planDepartmentCode
          ];
        });
        this.fileList=[]; */
          if (res.msg && res.data) {
            this.$alert(res.msg);
            window.location.href = `${res.data}`;
          } else {
            this.$message({
              showClose: true,
              message: this.$t('businesDepartment.businesList.exportSuccess'),
              type: 'success',
            });
            this.toList();
          }
        } else {
          this.$message({
            showClose: true,
            message: this.$t('businesDepartment.businesList.exportError'),
            type: 'error',
          });
        }
        // if (0 == res.code) {
        //   this.dialogUpload = false;
        //   if (res.msg) {
        //     this.$alert(res.msg);
        //     window.location.href = `${res.data}`;
        //   }else{
        //     this.$message({
        //       message: this.$t("import.importSuccess"),
        //       type: "success"
        //     });
        //   }
        //   //刷新列表
        //   // this.$emit("getData");
        // } else {
        //   this.$alert(res.msg);
        // }
      },
      //校验+保存
      save() {
        console.log(22);
        if (this.tableData.length <= 0) {
          this.$message({
            showClose: true,
            message: this.$t('businesDepartment.businesList.noSaveMates'),
            type: 'error',
          });
        } else {
          this.flag = true;
          // let formList = ['xTable'];
          let resultArr = [];
          // let _self = this;
          // function validates(formName) {
          //   let result = new Promise((resolve, reject) => {
          //     _self.$refs[formName]
          //       .validate()
          //       .then(() => {
          //         resolve();
          //       })
          //       .catch(() => {
          //         reject();
          //       });
          //   });
          //   resultArr.push(result);
          // }
          // formList.forEach((item) => {
          //   validates(item); // 循环校验
          // });
          // this.tableData = this.$refs.xTable.getTableData().fullData;
          Promise.all(resultArr)
            .then(() => {
              // 保存
              let flag1 = this.tableData.some((item) => {
                return (
                  (item.planCycle == 'CP' || item.planCycle == 'DP') &&
                  !item.paymentDate &&
                  typeof item.paymentDate != 'undefined' &&
                  item.paymentDate != 0
                );
              });
              let flag2 = this.tableData.some((item) => {
                return (item.planCycle == 'MP' || item.planCycle == 'HMP') && item.paymentDate;
              });
              /*  let flag3 = this.tableData.some(item => {

              return (
                item.paymentType == "SK01" &&
                !(item.receiveAmount==0?item.receiveAmount+'':item.receiveAmount)
              );
            });
            let flag4 = this.tableData.some(item => {
              return (
                item.paymentType == "SK02" &&
                !(item.payAmount==0?item.payAmount+'':item.payAmount)
              );
            }); */
              if (flag1) {
                this.$message({
                  showClose: true,
                  message: this.$t('businesDepartment.businesList.planDayHasAdd'),
                  type: 'error',
                });
                this.flag = false;
              } else {
                if (flag2) {
                  this.$message({
                    showClose: true,
                    message: this.$t('businesDepartment.businesList.planMonthHasAdd'),
                    type: 'error',
                  });
                  this.flag = false;
                }
              }
              /* if(flag3){
              this.$message({
                showClose: true,
                message: this.$t("businesDepartment.message.receiveAmount"),
                type: "error"
              });
              this.flag = false;
            }else{
              if(flag4){
                this.$message({
                showClose: true,
                message: this.$t("businesDepartment.message.payAmount"),
                type: "error"
              });
              this.flag = false;
              }
            } */
              if (this.flag) {
                const { tenantCode, companyCode, departmentCode, companyName, departmentName } =
                  this.user;
                let compareDate = true;
                let isSameDate = true;
                this.tableData.forEach((item) => {
                  item.tenantCode = tenantCode;
                  item.companyCode = companyCode;
                  item.departmentCode = departmentCode;
                  item.companyName = companyName;
                  item.departmentName = departmentName;
                  item.planCompanyName = this.companyList.find(
                    (res) => res.value === item.planCompanyCode
                  ).label;
                  if (item.planStartDate && item.planEndDate) {
                    isSameDate = XEUtils.isDateSame(item.planStartDate, item.planEndDate);
                    if (!isSameDate) {
                      compareDate = XEUtils.getDateDiff(item.planStartDate, item.planEndDate).done;
                      if (!compareDate) {
                        return;
                      }
                    }
                  }
                  if (item.receiveAmount == null || item.receiveAmount == '') {
                    item.receiveAmount = 0;
                  }
                  if (item.payAmount == null || item.payAmount == '') {
                    item.payAmount = 0;
                  }
                  //解决 axios 提交时间类型参数遇到的时区自动转换问题
                  /* if(item.planStartDate){
                  item.planStartDate = this.formatDate(Date.parse(item.planStartDate + 'GMT +8'),'yyyy-MM-dd');
                } */
                  if (item.planStartDate) {
                    item.planStartDate = this.formatDate(item.planStartDate, 'yyyy-MM-dd');
                  }
                  if (item.planEndDate) {
                    item.planEndDate = this.formatDate(item.planEndDate, 'yyyy-MM-dd');
                  }
                  if (item.paymentDate) {
                    item.paymentDate = this.formatDate(item.paymentDate, 'yyyy-MM-dd');
                  }
                });
                if (!compareDate) {
                  return this.$message({
                    showClose: true,
                    message: this.$t('businesDepartment.message.dateError'),
                    type: 'error',
                  });
                }
                let parames = {
                  businessDepartmentList: this.tableData,
                };
                this.load = true;
                this.$axios.post(API.SELECT_PLAN_BUSINESS_INSERT, parames).then((res) => {
                  this.load = false;
                  if (res.data.code == 0) {
                    this.$message({
                      showClose: true,
                      message: res.data.msg,
                      type: 'success',
                    });
                    this.toList();
                  } else {
                    this.$alert(res.data.msg);
                  }
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      },
      //增加
      insertEvent(row) {
        let xTable = this.$refs.xTable;
        // rowlist.fillinPerson = this.userInfo.userInfo.userName;
        let record = {};
        xTable.insertAt(record, row).then(({ row }) => {
          row.planDepartmentList = [];
          row.planDepartmentName = '';
          row.currencyType = 'CNY';
          xTable.setActiveRow(row);
        });
        this.tableData.forEach((item) => {
          item.fillinPerson = this.userInfo.userInfo.userName;
        });
        this.tableData = this.$refs.xTable.getTableData().fullData;
      },
      //复制
      copyEvent(row) {
        let xTable = this.$refs.xTable;
        let selectedList = xTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length < 1) {
          return this.$message({
            message: this.$t('businesDepartment.message.noData'),
            type: 'error',
          });
        }
        // rowlist.fillinPerson = this.userInfo.userInfo.userName;
        let record = {};
        changeList.forEach((item) => {
          xTable.insertAt(record, row).then(({ row }) => {
            // row.planDepartmentList = [];
            row.planCompanyCode = item.planCompanyCode;
            row.planDepartmentCode = item.planDepartmentCode;
            row.planCycle = item.planCycle;
            row.year = item.year;
            row.month = item.month;
            row.planStartDate = item.planStartDate;
            row.planEndDate = item.planEndDate;
            row.productName = item.productName;
            row.cashType = item.cashType;
            row.partnerName = item.partnerName;
            row.quantity = item.quantity;
            row.unitPrice = item.unitPrice;
            row.paymentType = item.paymentType;
            row.planDepartmentName = item.planDepartmentName;
            row.planDepartmentList = item.planDepartmentList;
            row.receiveAmount = item.receiveAmount;
            row.payAmount = item.payAmount;
            row.paymentDate = item.paymentDate;
            row.currencyType = item.currencyType;
            row.inputPerson = item.inputPerson;
            row.mark = item.mark;

            // row.currencyType="CNY";
            xTable.setActiveRow(row);
          });
        });

        /* this.tableData.forEach(item => {
        item.fillinPerson = this.userInfo.userInfo.userName;
      }); */
        this.tableData = this.$refs.xTable.getTableData().fullData;
      },
      // 删除
      handleDelete(tableTpye) {
        let selectedList = this.$refs.xTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('personnel.table.chockedLows'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            if (this.desable) {
              let ids = changeList.map((item) => {
                return item.id;
              });
              let params = {
                idList: ids,
              };
              this.$axios.post(API.DELETE_PLAN_BUSINESS, params).then((res) => {
                if (res.data.code == 0) {
                  this.$message({
                    showClose: true,
                    type: 'success',
                    message: res.data.msg,
                  });
                  this.$refs.xTable.removeSelecteds();
                  this.multipleSelection = [];
                  this.$refs.xTable.clearCheckboxReserve();
                  // this.getdata();
                } else {
                  this.$alert(res.data.msg);
                }
              });
            } else {
              this.$refs[tableTpye].removeSelecteds();
              this.tableData = this.$refs.xTable.getTableData().fullData;
              this.$message({
                showClose: true,
                type: 'success',
                message: this.$t('personnel.table.deletSuccess'),
              });
            }
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('personnel.table.deletFalse'),
            });
          });
      },
      //获取数据
      getdata() {
        if (this.$route.query.id) {
          //修改界面
          this.desable = true;
          if (this.$route.query.isShow == 1) {
            this.pageShow = true;
          }
          let ids = [];
          if (typeof this.routerData.id == 'string') {
            ids.push(this.routerData.id);
          } else {
            ids = this.routerData.id;
          }

          let params = {
            idList: ids,
            pageNum: this.page.pageNum,
            pageSize: this.page.pageSize,
          };
          this.loading.startLoading();
          this.$axios.post(API.SELECT_PLAN_BUSINESS_DETAIL, params).then((res) => {
            this.loading.endLoading();
            if (res.data.code == 0) {
              this.tableData = res.data.data.records;
              this.tableData.forEach((item) => {
                item.companyDepartment = [item.planCompanyCode, item.planDepartmentCode];
              });
              this.page.total = res.data.data.total;
            }
          });
        } else {
          //创建页面
          this.desable = false;
          this.pageShow = false;
        }
      },
      handleChange(value) {
        this.tableData.forEach((item) => {
          if (item._XID == value._XID) {
            item.planCompanyCode = value.companyDepartment[0];
            item.planDepartmentCode = value.companyDepartment[1];
            this.companyDepartmentList.forEach((res) => {
              if (res.value == item.planCompanyCode) {
                // item.planDepartmentName = res.label;
                item.planCompanyName = res.label;
                res.children.forEach((val) => {
                  if (val.value == item.planDepartmentCode) {
                    item.planDepartmentName = val.label;
                  }
                });
              }
            });
          }
        });
      },
      getCascaderLabel(val, value, list) {
        let values = value || [];
        let labels = [];
        let matchCascaderData = function (index, list) {
          let val = values[index];
          if (list && values.length > index) {
            list.forEach((item) => {
              if (item.value === val) {
                labels.push(item.label);
                matchCascaderData(++index, item.children);
              }
            });
          }
        };
        matchCascaderData(0, list);
        if (val == 1) {
          return labels[0];
        } else {
          return labels[1];
        }
      },
      handleSizeChange(value) {
        this.page.pageSize = value;
        this.getData();
      },
      handleCurrentChange(value) {
        this.page.pageNum = value;
        this.getData();
      },
      // 选中事件
      handleSelectionChange(val) {
        this.multipleSelection = val.selection;
      },
      // 资金计划报表根据选择的年月限制选择的日期范围
      handleFocusDateFin(year, month, planStartDate, planEndDate) {
        let timeStart = year + '/' + month + '/01';
        let timeEnd = new Date(timeStart);
        timeEnd.setMonth(timeEnd.getMonth() + 1);
        let dateTime = new Date(timeEnd).getTime() - 24 * 60 * 60 * 1000;
        if (planStartDate) {
          timeStart = planStartDate;
        }
        if (planEndDate) {
          timeEnd = planEndDate;
          dateTime = new Date(timeEnd).getTime();
        }
        this.pickerTimeOptions = {
          disabledDate: (time) => {
            return time.getTime() < new Date(timeStart).getTime() || time.getTime() > dateTime;
          },
        };
      },
      handleFocusDateFinPaymentDate(planStartDate, planEndDate) {
        this.pickerTimeOptions = {
          disabledDate: (time) => {
            return (
              time.getTime() < new Date(planStartDate).getTime() ||
              time.getTime() > new Date(planEndDate).getTime()
            );
          },
        };
      },
      getDictionary() {
        this.getCurrencyList();
        this.getPayForList();
        this.getYearList();
        this.getCompany();
        this.getPaymentTypeList();
        this.getPlanWeekList();
      },
      //获取当前年度往后推三年
      getYearList() {
        let date = new Date();
        let year = date.getFullYear();
        year = year - 1;
        for (let i = 0; i < 4; i++) {
          year = year + 1;
          let object = { value: `${year}`, label: year };
          this.yearList.push(object);
        }
      },
      //获取计划周期
      async getPlanWeekList() {
        let params = {
          dictType: 'capitalPlan_plan_week',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.planWeekList = selectStatus.data.data;
        }
      },
      //获取币别
      async getCurrencyList() {
        const selectStatus = await this.$axios.get(BASEAPI.LIST_CURRENCY);
        if (selectStatus.data.code == 0) {
          selectStatus.data.data.map((item) => {
            let obj = {
              value: item.currencyCode,
              label: item.currencyName,
            };
            this.currencyList.push(obj);
          });
        }
      },
      //获取收付款方式
      async getPayForList() {
        let params = {
          dictType: 'capitalPlan_plan_paymentType',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.payForWayList = selectStatus.data.data;
        }
      },
      //获取表格公司
      async getCompany() {
        const params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
          //personCompanyCode: this.userInfo.userInfo.companyCode
        };
        const selectStatus = await this.$axios.post(BASEAPI.GET_PERSON_API, params);
        if (selectStatus) {
          this.companyList = selectStatus.data.data.personCompanyInfo;
          this.companyList.forEach((item) => {
            item.value = item.personCompanyCode;
            item.label = item.personCompanyName;
          });
        }
        /*
      let res = await this.$baseRequest.getCompanyList();
      if (res) {
        this.companyList = res;
      } */
      },
      //获取款项类型列表
      async getPaymentTypeList() {
        let params = {
          dictType: 'capitalPlan_plan_cashType',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.paymentTypeList = selectStatus.data.data;
        }
      },
      changPlanCysle(scope) {
        scope.row.paymentDate = null;
        this.$refs.xTable.updateStatus(scope);
      },
      changPaymentType(scope) {
        //SK01 收款  SK02付款
        if (scope.row.unitPrice && scope.row.quantity && scope.row.paymentType) {
          if (scope.row.paymentType == 'SK01') {
            scope.row.receiveAmount = this.$cal.calCommon(
              scope.row.unitPrice,
              scope.row.quantity,
              '*',
              'amount'
            );
            scope.row.payAmount = '0';
          } else if (scope.row.paymentType == 'SK02') {
            scope.row.payAmount = this.$cal.calCommon(
              scope.row.unitPrice,
              scope.row.quantity,
              '*',
              'amount'
            );
            scope.row.receiveAmount = '0';
          }
        } else {
          scope.row.receiveAmount = '0';
          scope.row.payAmount = '0';
        }
        this.$refs.xTable.updateStatus(scope);
      },
      changPlanDate(scope, type) {
        if (type == 'planStartDate') {
          if (scope.row.year && scope.row.month) {
            if (scope.row.planCycle == 'MP' && !scope.row.planStartDate) {
              let timeStart = scope.row.year + '/' + scope.row.month + '/01';
              let timeEnd = new Date(timeStart);
              timeEnd.setMonth(timeEnd.getMonth() + 1);
              scope.row.planStartDate = new Date(timeStart).getTime();
              scope.row.planEndDate = new Date(timeEnd).getTime() - 24 * 60 * 60 * 1000;
            } else if (scope.row.planCycle == 'DP') {
              scope.row.planEndDate = scope.row.planStartDate;
            }
          } else {
            scope.row.planStartDate = null;
            scope.row.planEndDate = null;
            scope.row.paymentDate = null;
          }
        } else {
          if (scope.row.year && scope.row.month) {
            if (scope.row.planCycle == 'MP') {
              let timeStart = scope.row.year + '/' + scope.row.month + '/01';
              let timeEnd = new Date(timeStart);
              timeEnd.setMonth(timeEnd.getMonth() + 1);
              scope.row.planStartDate = new Date(timeStart).getTime();
              scope.row.planEndDate = new Date(timeEnd).getTime() - 24 * 60 * 60 * 1000;
            } else if (scope.row.planCycle == 'DP') {
              scope.row.planEndDate = scope.row.planStartDate = null;
            }
            scope.row.paymentDate = null;
          } else {
            scope.row.planStartDate = null;
            scope.row.planEndDate = null;
            scope.row.paymentDate = null;
          }
        }
        this.$refs.xTable.updateStatus(scope);
      },
      changPlanDate2(row) {
        if (row.planCycle == 'DP') {
          row.planEndDate = row.planStartDate;
        }
        this.$refs.xTable.updateStatus(row);
      },
    },
  };
</script>
<style lang="scss" scoped>
  $maintheme: #6299fe;
  .safeguardDepartment .creatButton {
    background-color: rgb(98, 153, 254) !important;
    border: 1px solid rgb(98, 153, 254) !important;
    min-width: 80px;
    border-radius: 2px !important;
    margin-bottom: 10px;
  }
  .safeguardDepartment .deteButton {
    background-color: #fe8783 !important;
    border: 1px solid #fe8783 !important;
    min-width: 80px;
    border-radius: 2px !important;
    margin-bottom: 10px;
  }
  .safeguardDepartment .el-pagination {
    float: right;
    padding: 10px 5px;
  }
  .upload-demo {
    height: 150px;
  }
  .el-button {
    border: 1px solid $maintheme;
    color: $maintheme;
  }
  .el-button--primary {
    color: #fff;
    background-color: $maintheme;
    border-color: $maintheme;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: unset !important;
  }
</style>
